<div *ngIf="pumpset" class="pumpset" >
  <div style="padding-bottom:10px"><status-bar [status]="status"></status-bar></div>
  <dx-accordion #accordion
    (onItemTitleClick)="selectElement($event.itemData.selector)"
    [dataSource]="sections"
    [animationDuration]="1"
    [collapsible]="true"
    [multiple]="false"
    [selectedIndex]="-1">
    <div *dxTemplate="let section of 'title'">
      <div style="width:95%;">
        <div style="width:50%;display:inline-block;">
          <span>{{section.title}} : </span>
          <span [style.color]="section.error?'red':'#00919b'">{{section.summary}}</span>
        </div>
        <div style="width:50%;display:inline-block;text-align:right">          
          <dx-button *ngIf="section.template=='booster'" [text]="plusup" icon=""  hint="Add Booster Layer above" (onClick)="addBoosterAbove(section.boosterNumber)" class="layer-button"></dx-button>
          <dx-button *ngIf="section.template=='booster'"  icon="trash"  style="margin-right: 10px;margin-left:10px" hint="Remove this Booster Layer" (onClick)="removeBooster(section.boosterNumber)" class="layer-button" ></dx-button>
          <dx-button *ngIf="section.template=='booster'" [text]="plusdown" icon=""  hint="Add Booster Layer below" (onClick)="addBoosterBelow(section.boosterNumber)" class="layer-button"></dx-button>
          <dx-button *ngIf="section.template=='backing-pump' && section.numBoosters==0" [text]="plusup" hint="Add Booster Layer above" (onClick)="addBooster(0)"  class="layer-button"></dx-button>
        </div>
      </div>
    </div>
    <div *dxTemplate="let section of 'booster'" style="background:#EAF4F5">
      <app-booster-form
        [id]="section.id"
        [boosterLayer]="section.data"
        [boosterNumber]="section.boosterNumber"
        [errors]="errors"
        (boosterChange)="boosterChange($event)"
        >
      </app-booster-form>
    </div>
    <div *dxTemplate="let section of 'backing-pump'" style="background:#EAF4F5">
      <app-backing-pump-form
        [backingPump]='{id:pumpset.pumpsetDetails.backingPumpId,name:pumpset.pumpsetDetails.backingPumpName,parallel:pumpset.pumpsetDetails.numberOfBackingPumpsInParallel,gas:pumpset.pumpsetDetails.backingPumpGas}'
        [errors]="errors"
        (backingPumpChange)="changeBackingPump($event)">
      </app-backing-pump-form>
    </div>
  </dx-accordion>
</div>
<div *ngIf="pumpset" style="width:400px; padding-top:15px">
  <app-pumpset-form
    [pumpSet]="pumpset"
    [errors]="errors">
  </app-pumpset-form>  
</div>

